import React, { useEffect, useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const GA_ID = 'G-JWFYQ80G6W';
const CONSENT_KEY = 'cookie_consent_ga4';

const loadGtag = () => {
  if (typeof window === 'undefined') return;
  if (window.gtagLoaded) return;
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  script.onload = () => {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag(){window.dataLayer.push(arguments);};
    window.gtag('js', new Date());
    window.gtag('config', GA_ID);
    window.gtagLoaded = true;
  };
  document.body.appendChild(script);
};

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const saved = window.localStorage.getItem(CONSENT_KEY);
    // Stub dataLayer/gtag so calls don't fail before consent
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function gtag(){window.dataLayer.push(arguments);};

    if (saved === 'accepted') {
      loadGtag();
    } else {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem(CONSENT_KEY, 'accepted');
    setVisible(false);
    loadGtag();
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-banner__text">
        {t('cookies.bannerText')}
      </div>
      <div className="cookie-banner__actions">
        <button className="btn-secondary" onClick={() => setVisible(false)}>
          {t('cookies.decline')}
        </button>
        <button className="btn-primary" onClick={accept}>
          {t('cookies.accept')}
        </button>
      </div>
    </div>
  );
};

